import { GraphType } from '@/graphql/types';
import { useMemo } from 'react';
import { DATA_TYPE, ScaleType } from '../../../graph/enums';
import { ValueScaleEquation } from '../../../graph/auto-scale';
import { TemplateEditor } from './TemplateEditor';
import type { PageSettings } from './pageSettings';
import type { ReportStructureController } from './reportStructureController';
import type {
    ElementDefinition,
    GraphTimeWindow,
    RenderRuntimeGraphSettings,
    RenderRuntimeDataServices,
    RenderContext,
} from './elements/types';

interface EditorProps {
    structure: ElementDefinition[];
    structureController: ReportStructureController;
    pageSettings: PageSettings;
    context: RenderContext;
    previewDateRange: GraphTimeWindow;
    runtimeDataServices: RenderRuntimeDataServices;
}

const previewGraphSettings: Omit<RenderRuntimeGraphSettings, keyof GraphTimeWindow> = {
    preferredGraphType: GraphType.Bar,
    frequencyGraphScaleType: ScaleType.Auto,
    dataType: DATA_TYPE.VTOP,
    valueScale: null,
    valueScaleEquation: ValueScaleEquation.VIBRATION,
    frequencyScale: null,
    hiddenLines: [],
    getAlarmsUrl: (id) => `/sbr/get_alarms/${id}/`,
};

export function Editor({
    structure,
    structureController,
    pageSettings,
    context,
    previewDateRange,
    runtimeDataServices,
}: EditorProps): JSX.Element {
    const { viewStartTs, viewEndTs } = previewDateRange;
    const graphSettings = useMemo(
        () => ({ ...previewGraphSettings, viewStartTs, viewEndTs }),
        [viewStartTs, viewEndTs]
    );

    return (
        <TemplateEditor
            structure={structure}
            context={context}
            pageSettings={pageSettings}
            graphSettings={graphSettings}
            structureController={structureController}
            runtimeDataServices={runtimeDataServices}
        />
    );
}
